import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { ParametersDataGrid } from '../../components/datagrid/ParametersDataGrid';
import { useAssetClass } from '../../contexts/assetClass';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { Parameter } from '../../types/parameter.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function Parameters() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();
  const { assetClass } = useAssetClass();
  useEffect(() => {
    setValue({ pageName: 'Parameters', steps: [{ name: 'Home', pathToCutCount: 1 }] });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<Parameter[]>(
    `${API_URL.PARAMETER_BY_CLASS_LIST}?classId=${assetClass}&visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/parameters/edit/${e.row.data.id}`);
  };
  return (
    <PageContentWrapper error={error} loading={!data}>
      <ParametersDataGrid data={data} handleEdit={handleEditButton} />
    </PageContentWrapper>
  );
}
export default Parameters;
